/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService
 */

export let ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsGetSettingsError;
(function (_ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsGetSettingsError) {})(ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsGetSettingsError || (ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsGetSettingsError = {}));
export let ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsUpdateSettingsError;
(function (_ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsUpdateSettingsError) {})(ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsUpdateSettingsError || (ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsUpdateSettingsError = {}));
export const updateSettingsV2Rpc = {
  serviceName: 'com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService',
  rpcName: 'updateSettingsV2',
  auth: 'app',
  fingerprint: 'h-No_L5vTUadh2e2tZ4AoZ2SlnStQRiY',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSettingsRpc = {
  serviceName: 'com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService',
  rpcName: 'getSettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAuMB5dLVlRwFfJOp6dOEjo',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSettingsV2Rpc = {
  serviceName: 'com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService',
  rpcName: 'getSettingsV2',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADbRgKQ-703TlfJOp6dOEjo',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const areReplyRecsEnabledRpc = {
  serviceName: 'com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService',
  rpcName: 'areReplyRecsEnabled',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACzlfBUgnMg6Lio01o5cyE4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};